export const CovetrusLobaConnectionPhases = {
  Loading: "loading",
  SelectAccount: "select-account",
  Error: "error",
} as const;

export type CovetrusLobaConnectionPhase =
  (typeof CovetrusLobaConnectionPhases)[keyof typeof CovetrusLobaConnectionPhases];
